import { ArrowDown, ShieldCheck, MapPin, Hammer } from "lucide-react";
import { COMPANY } from "@/data/services";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-white">
      <div className="absolute inset-0 bg-grid opacity-60 pointer-events-none" />
      <div className="container mx-auto px-4 md:px-8 pt-12 md:pt-20 pb-12 md:pb-20 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7 animate-fade-up">
            <div className="flex items-center gap-4 mb-6">
              <img
                src={COMPANY.logo}
                alt={COMPANY.name}
                className="w-16 h-16 md:w-20 md:h-20 rounded-2xl object-contain bg-white border border-slate-200 shadow-sm p-1"
                data-testid="hero-logo-img"
              />
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#E6F0FA] border border-[#004B87]/15 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#004B87]">
                <ShieldCheck className="w-3.5 h-3.5" />
                Empresa S.L.U. registrada · Valencia
              </div>
            </div>
            <h1 className="font-display font-bold text-slate-900 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tighter">
              Calcula una estimación <span className="text-[#004B87]">orientativa</span> para tu reforma en Valencia
            </h1>
            <p className="font-display text-lg md:text-xl text-slate-700 mt-4 leading-relaxed max-w-2xl">
              Reformas, construcción, baños, pladur, alicatados, pavimentos, pintura, fontanería, electricidad e impermeabilizaciones con empresa S.L.U., equipo propio, personal asegurado y trabajos con garantía.
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <a
                href="#calculadora"
                data-testid="hero-start-calc-btn"
                className="inline-flex items-center gap-2 h-12 px-6 rounded-lg bg-[#004B87] text-white font-medium hover:bg-[#003A6A] transition-colors shadow-sm"
              >
                Calcular presupuesto orientativo <ArrowDown className="w-4 h-4" />
              </a>
              <a
                href={`https://wa.me/${COMPANY.whatsappIntl}`}
                target="_blank" rel="noreferrer"
                data-testid="hero-whatsapp-btn"
                className="inline-flex items-center gap-2 h-12 px-6 rounded-lg border border-slate-300 bg-white text-slate-900 font-medium hover:border-[#004B87] hover:text-[#004B87] transition-colors"
              >
                Solicitar visita por WhatsApp
              </a>
            </div>

            <p className="mt-5 text-xs text-slate-500 leading-relaxed max-w-xl">
              Empresa S.L.U. · NIF {COMPANY.nif} · {COMPANY.area} · Personal asegurado · Presupuesto tras visita técnica
            </p>

            <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
              <Stat number="12" label="Especialidades cubiertas" />
              <Stat number="100%" label="Empresa registrada" />
              <Stat number="✓" label="Personal asegurado y garantía" />
            </div>
          </div>

          <div className="lg:col-span-5 relative">
            <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_60px_-20px_rgba(0,75,135,0.35)] border border-slate-200">
              <img
                src="https://images.pexels.com/photos/36035073/pexels-photo-36035073.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Reforma en proceso en Valencia"
                className="w-full h-[420px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F]/80 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 text-white">
                <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] opacity-90 mb-2">
                  <MapPin className="w-3.5 h-3.5" /> Valencia y provincia
                </div>
                <div className="font-display font-semibold text-2xl leading-tight">
                  Reformas serias, profesionales y garantizadas.
                </div>
              </div>
            </div>
            <div className="absolute -bottom-6 -left-6 hidden md:block bg-white border border-slate-200 rounded-xl shadow-lg p-4 max-w-[220px]">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-[#E6F0FA] grid place-items-center text-[#004B87]">
                  <Hammer className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-xs text-slate-500">Desde</div>
                  <div className="font-display font-bold text-lg text-slate-900">180€</div>
                  <div className="text-[10px] text-slate-500">Intervención mínima</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ number, label }) {
  return (
    <div>
      <div className="font-display font-bold text-2xl md:text-3xl text-slate-900 leading-none">{number}</div>
      <div className="text-xs text-slate-500 mt-1.5 leading-tight">{label}</div>
    </div>
  );
}
